/*
 * Prev/next arrows over the main product image.
 *
 * Dawn only ships slider arrows for the mobile carousel; on desktop the
 * thumbnail layouts leave the main image with no keyboard or click affordance.
 * This drives Dawn's own media-gallery.setActiveMedia() so thumbnails, zoom and
 * the a11y live region all stay in sync.
 */
class HBGalleryNav extends HTMLElement {
  connectedCallback() {
    this.gallery = this.closest('media-gallery');
    if (!this.gallery) return;

    this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
    if (!this.viewer) return;

    this.counter = this.querySelector('[data-hb-gallery-counter]');
    this.querySelector('[data-hb-gallery-prev]').addEventListener('click', () => this.step(-1));
    this.querySelector('[data-hb-gallery-next]').addEventListener('click', () => this.step(1));

    // Keep the counter honest when the shopper uses thumbnails instead.
    this.observer = new MutationObserver(() => this.updateCounter());
    this.observer.observe(this.viewer, { attributes: true, subtree: true, attributeFilter: ['class'] });

    this.updateCounter();
  }

  get items() {
    return Array.from(this.viewer.querySelectorAll('[data-media-id]'));
  }

  get currentIndex() {
    const index = this.items.findIndex((item) => item.classList.contains('is-active'));
    return index === -1 ? 0 : index;
  }

  step(direction) {
    const items = this.items;
    if (items.length < 2) return;
    const next = items[(this.currentIndex + direction + items.length) % items.length];
    this.gallery.setActiveMedia(next.dataset.mediaId, false);
    this.updateCounter();
  }

  updateCounter() {
    if (!this.counter) return;
    this.counter.textContent = `${this.currentIndex + 1} / ${this.items.length}`;
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('hb-gallery-nav')) {
  customElements.define('hb-gallery-nav', HBGalleryNav);
}
